import { createContext, useContext, useState, ReactNode } from "react";

type EditModeContextType = {
  isEditMode: boolean;
  setIsEditMode: (value: boolean) => void;
};

const EditModeContext = createContext<EditModeContextType | undefined>(
  undefined,
);

export const EditModeProvider = ({ children }: { children: ReactNode }) => {
  const [isEditMode, setIsEditMode] = useState(false);

  return (
    <EditModeContext.Provider value={{ isEditMode, setIsEditMode }}>
      {children}
    </EditModeContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useEditMode = () => {
  const context = useContext(EditModeContext);
  if (!context)
    throw new Error("useEditMode must be used within EditModeProvider");
  return context;
};
